import { connect } from 'react-redux'
import { selectCurrentTicket } from 'selectors/tickets'
import View from './view'

const select = state => ({
  ticket: selectCurrentTicket(state),
})

export default connect(select)(View)
